export default __webpack_public_path__ + "static/media/continue-btn.61894ab2.png";